exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 600px) {\n.modal-header span[data-v-65276552] {\n    margin-top: 20px;\n}\n}\n.verify-phone-number[data-v-65276552] {\n  padding: 25px;\n  padding-bottom: 5px;\n}\n.profile-block-actions-btn[data-v-65276552] {\n  width: 40%;\n  margin: 10px 30px;\n  border-radius: 5px;\n}\n", ""]);

// exports
